import { createSelector } from 'reselect'

const getOnboarding = (state: any) => state.get('persist').onboarding

export const isLoading = createSelector(getOnboarding, onboarding => onboarding.get('isLoading'))

export const selectedProTrackLevelId = createSelector(getOnboarding, onboarding =>
  onboarding.get('selectedProTrackLevelId')
)
